import * as api from '@/http'

export const ActionSetStates = async ({ commit }) => {
  const utils = await api.http.get('dash/utils/assets').then(
    (response) => response.body,
    (error) => error
  )
  commit('acquisitions/SET_acquisitionTypes', utils.acquisition_types, { root: true })
  commit('acquisitions/SET_acquisitionCategories', utils.acquisition_categories, { root: true })
  commit('acquisitions/SET_acquisitionSources', utils.acquisition_sources, { root: true })
  commit('acquisitions/SET_providers', utils.providers, { root: true })
  commit('assets/SET_assets', utils.assets, { root: true })
  commit('conditions/SET_conditions', utils.conditions, { root: true })
  commit('departments/SET_departments', utils.departments, { root: true })
  commit('entities/SET_entities', utils.entities, { root: true })
  commit('external_employees/SET_externalEmployee', utils.external_employees, { root: true })
  commit('movements/SET_movements', utils.movements, { root: true })
  commit('movements/SET_movementTypes', utils.movement_types, { root: true })
}
